import {IAccount} from "../../stores/accounts/account";

export interface IClient {
  id: number;
  clientName: string;
  description: string;
  seekTenant?: string;
  dialogFlowProject?: string;
}

export function toClient(account: IAccount): IClient {
  return {
    id: account.id,
    clientName: account.accountName,
    description: account.description,
    seekTenant: account.seekFolder,
    dialogFlowProject: account.dialogFlowProject,
  }
}
